// JS for block-specific behavior only
$('.industries-bottom').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 2,
    autoplay: false,
    arrows: false,
    dots: true,
    responsive: [
        {
            breakpoint: 766,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 534,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});